import { ERROR, GET_IS_AUTH } from "../reducers/index";
import axios from "axios";

export const getIsAuthSuccess = (content) => ({
  type: GET_IS_AUTH,
  payload: content,
});

export const getIsAuthError = (content) => ({
  type: ERROR,
  payload: content,
});

export const getIsAuth = () => async (dispatch, getState) => {
  const { api } = getState().paths;
  const url = `${api}/authenticated`;

  try {
    const response = (await axios.get(url)).data;
    dispatch(getIsAuthSuccess(response));
  } catch (e) {
    dispatch(getIsAuthError(e.toString()));
  }
};
